// ============================================
// FLOATINGINPUT.JS - Input con label flotante
// ============================================

import React, { useState } from 'react';
import './FloatingInput.css';

const FloatingInput = ({
  type = 'text',
  name,
  label,
  value,
  onChange,
  error,
  disabled = false,
  required = false,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const hasValue = value && value.toString().length > 0;
  const isActive = isFocused || hasValue;

  return (
    <div className={`floating-input ${isActive ? 'is-active' : ''} ${error ? 'has-error' : ''} ${disabled ? 'is-disabled' : ''}`}>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        disabled={disabled}
        required={required}
        className="floating-input__field"
      />
      <label className="floating-input__label">
        {label}
        {required && <span className="floating-input__required">*</span>}
      </label>
      {error && <span className="floating-input__error">{error}</span>}
    </div>
  );
};

export default FloatingInput;
